import TextButton from 'components/Luxkit/Button/TextButton'
import React from 'react'

function SearchTilePrimaryActionButton() {
  return <TextButton nonInteractable kind="primary">View offer</TextButton>
}

export default SearchTilePrimaryActionButton
